import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MissionStateForm_Mission_ActionPermissions_QueryDocument = graphql(
  `
    query MissionStateForm_Mission_ActionPermissions_Query($id: Id!) {
      findOneMission(id: $id) {
        access {
          actions {
            ...FolderBusinessEntityStateForm_ActionPermission_Fragment
          }
        }
      }
    }
  `,
);

export type MissionStateForm_Mission_ActionPermissions = ResultOf<
  typeof MissionStateForm_Mission_ActionPermissions_QueryDocument
>['findOneMission'];

export const useFindAllMissionActionPermissionsQuery = (
  id = EMPTY_ID,
  enabled = !!id,
) =>
  useGraphQLQuery(
    MissionStateForm_Mission_ActionPermissions_QueryDocument,
    { id },
    { enabled: !!id && enabled },
  );
